import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	subjectLabel: {
		id: 'language-settings.email-template-panel.subject-label',
		defaultMessage: 'Subject',
		description: 'Label for the subject text field',
	},
	stylesTitle: {
		id: 'language-settings.email-template-panel.styles-title',
		defaultMessage: 'Styles',
		description: 'Title for the styles section',
	},
	htmlSubtitle: {
		id: 'language-settings.email-template-panel.html-subtitle',
		defaultMessage: 'HTML',
		description: 'Label for the html tab',
	},
	cssSubtitle: {
		id: 'language-settings.email-template-panel.css-subtitle',
		defaultMessage: 'CSS',
		description: 'Label for the css tab',
	},
	textSubtitle: {
		id: 'language-settings.email-template-panel.text-subtitle',
		defaultMessage: 'Plain text',
		description: 'Label for the plain text tab',
	},
	emailTemplatePreviewModalTitle: {
		id: 'language-settings.email-template-panel.email-template-preview-modal-title',
		defaultMessage: 'Preview: Customer notification template',
		description: 'Modal title for the preview dropdown items modal',
	},
	htmlEmailLabel: {
		id: 'language-settings.email-template-panel.html-email-label',
		defaultMessage: 'HTML email',
		description: 'Label for the html email body',
	},
	plainTextEmailLabel: {
		id: 'language-settings.email-template-panel.plain-text-email-label',
		defaultMessage: 'Plain text email',
		description: 'Label for the Plain text email body',
	},
	insertVariableTrigger: {
		id: 'language-settings.email-template-panel.insert-variable-trigger',
		defaultMessage: 'Insert variable',
		description: 'Label for trigger of the dropdown to insert variables into the subject field',
	},
	sendTestEmailLabel: {
		id: 'language-settings.email-template-panel.send-test-email-label',
		defaultMessage: 'Send me a test email',
		description:
			'Label for the Send test email field. This field used to send html email or plain text email to the user',
	},
	previewLabel: {
		id: 'language-settings.email-template-panel.preview-label',
		defaultMessage: 'Preview',
		description:
			'Label for the preview field. This field shows the user what the customer html email body will look like.',
	},
	hiddenFromEmailContent: {
		id: 'language-settings.email-template-panel.hidden-from-email-content',
		defaultMessage: 'Hidden from email content',
		description: 'Tooltip message for privacy unsafe variable icon',
	},
	translationTab: {
		id: 'language-settings.email-template-panel.translation-tab',
		defaultMessage: 'Translation',
		description: 'Label for the translation tab',
	},
	translationDefaultTab: {
		id: 'language-settings.email-template-panel.translation-default-tab',
		defaultMessage: 'Project default',
		description: 'Label for the translation default tab',
	},
});
